// File Baru: src/services/create-booking-v4/hooks/useSendInvoiceV4.ts

import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { toast } from "sonner";

/**
 * Custom hook untuk mengirim invoice ke pelanggan.
 * Menggunakan useMutation untuk menangani aksi POST.
 * 
 * @returns {object} - Objek yang berisi fungsi `mutate` (dengan alias `sendInvoice`) 
 *                      dan state `isPending` (dengan alias `isSending`).
 */
export const useSendInvoiceV4 = () => {
    return useMutation({
        /**
         * Fungsi mutasi yang akan dipanggil.
         * Menerima nomor invoice sebagai argumen.
         * @param {string} invoiceNumber - Nomor invoice yang akan dikirim.
         */
        mutationFn: async (invoiceNumber: string) => {
            // Memastikan invoiceNumber ada sebelum membuat panggilan API
            if (!invoiceNumber) {
                throw new Error("Invoice number is required to send an invoice.");
            }
            // Melakukan panggilan API dengan metode POST ke endpoint yang sesuai
            // Diasumsikan tidak ada body yang diperlukan untuk permintaan ini
            return await privateApi.post(`/v4/send-invoice/${invoiceNumber}`);
        },

        /**
         * Callback yang dijalankan saat mutasi berhasil.
         */
        onSuccess: () => {
            // Menampilkan notifikasi sukses kepada pengguna
            toast.success("Invoice has been sent successfully", {
                id: 'send-invoice', // ID untuk mencegah duplikasi toast
            });
        },

        /**
         * Callback yang dijalankan saat mutasi gagal.
         * @param {any} error - Objek error yang dilempar oleh `mutationFn`.
         */
        onError: (error: any) => {
            // Menampilkan notifikasi error dengan pesan dari API atau pesan default
            toast.error(error?.response?.data?.message || "Failed to send the invoice. Please try again.", {
                id: 'send-invoice',
            });
        },
    });
};